import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { GridViewService } from 'src/app/shared/services/grid-view.service';
import { Router } from '@angular/router';
import { GlobalServices } from '../../services/global.service';
import { Languages, Service } from '../../models/enums.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AppConfig } from '../../services/app.config';
import { AgentStatus } from 'src/app/admin/e-services/e-booking/agent-registration-request/offline-agent-list/offline-agent-list.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Listing } from '../../models/listing.model';
import { SupplierListComponent } from 'src/app/admin/e-services/e-tender/supplier-list/supplier-list.component';
import { MenuItem } from '../ebooking-report/ebooking-report.component';
import { windowWhen } from 'rxjs/operators';

@Component({
  selector: 'app-grid-view',
  templateUrl: './grid-view.component.html'
})

export class GridViewComponent implements OnInit {
  //#region Variables
  //HTML Variables
  public isGridValid: boolean = false;
  public isGridEmpty: boolean = false;
  private gridCollection;
  private localizedObjectName: string = "";
  private isSortingHeader: boolean = false;
  private menuItems = [];
  //TS Variables
  private gridHeaders: string[] = [];
  private collectionTotalCount: number = 0;
  private gridViewSize: number = 0;
  private noOfPages: number = 0;
  private noOfPagesArr: number[] = [];
  private currentPage: number = 1;
  private collectionPagedSortedEndPoint: string = "";
  private sortingKeysDir: SortKey[] = [];
  private currentUsedSortByKey: string = "";
  private currentUsedSortDirKey: string = "";
  public currentLanguage;
  public componentName;
  public currentUser: User = new User();
  private services: ServicesProcessGUID[] = [];
  private nameGrid: string;
  private baseRequestId: string = "";
  public showPrevDots = false;
  public showNextDots = false;
  private sortingColumns: string[][] = [];

  //#endregion
  listData: Listing;
  @Input() customMenuTemplate: TemplateRef<any>;
  @Input() private IsHtml: Boolean = false;
  @Input() private HasMenu: Boolean = true;
  @Input() private HasMenuButtons: Boolean = false;
  @Output() loadItemsMenu: EventEmitter<any> = new EventEmitter();
  @Output() handleMenuItemClick: EventEmitter<any> = new EventEmitter();
  constructor(private gridViewService: GridViewService, private sanitized: DomSanitizer, private router: Router, private global: GlobalServices, private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;
    //this.currentUser = this.global.user;

    if (this.currentUser != null && this.currentUser.IsAdmin) {
      this.fillServicesDictionary();
    }

  }

  ngOnInit() {
    this.currentLanguage = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    this.loadSortandPagingCriteria();
  }

  public loadGrid(collection, totalCount, pageSize, collectionPagedSortedEndPoint, localizedObjectName,
    itemsMenu, primarySortColumn, primarySortDirection, secondarySortColumn?, secondarySortDirection?, componentName?, nameGrid = null) {
      
    this.listData = collection;
    this.nameGrid = nameGrid;
    this.currentPage = 1;
    this.isGridValid = false;
    this.isGridEmpty = false;
    this.collectionTotalCount = totalCount;
    this.componentName = componentName;
    if (this.collectionTotalCount > 0 && pageSize >= 0) {

      this.sortingColumns.push([secondarySortColumn, secondarySortDirection]);
      //this.sortingColumns.push([secondarySortColumn, secondarySortDirection]);
      if (this.sortingColumns.length > 2)
        this.sortingColumns.shift();

      this.sortingColumns.push([primarySortColumn, primarySortDirection]);
      //this.sortingColumns.push([primarySortColumn, primarySortDirection]);
      if (this.sortingColumns.length > 2)
        this.sortingColumns.shift();


      this.buildGrid(collection, pageSize);
      this.collectionPagedSortedEndPoint = collectionPagedSortedEndPoint;
      this.localizedObjectName = localizedObjectName;
      this.menuItems = itemsMenu;

      // this means that there are stored crieteria for sorting and paging
      if (this.global.myTasksSortsndPagingCriteria.length > 0) {
        this.loadSortandPagingCriteria();

        primarySortColumn = this.sortingColumns[1][0];
        primarySortDirection = this.sortingColumns[1][1];

        secondarySortColumn = this.sortingColumns[0][0];
        secondarySortDirection = this.sortingColumns[0][1];
      }
      //--------------------------------------------------------

      if (this.componentName == 'LongHaulRequestsManagement')
        this.highlightSortingColumn(primarySortColumn, primarySortDirection == "ASC" ? true : false);
      else if (this.componentName == 'MyTasks' ||this.componentName == 'ReleaseTasks' || this.componentName == 'SmallUnitsTasks' || this.componentName == "CircularTasks"|| this.componentName == "ChangeCrewTasks") {
        this.clearMultipleSortingColumns();
        for (let index = 0; index < this.sortingColumns.length; index++) {
          this.highlightMultipleSortingColumn(this.sortingColumns[index][0], this.sortingColumns[index][1] == "ASC" ? true : false);
        }
        //this.highlightSortingColumn(primarySortColumn, primarySortDirection == "ASC" ? true : false);
        // this.highlightSortingColumn(secondarySortColumn, secondarySortDirection == "ASC" ? true : false);
      }
      this.isGridValid = true;

    }
    else if (this.collectionTotalCount == 0) {
      this.isGridEmpty = true;
    }
    // if(this.IsHtml){
    //   this.loadButtons(collection);
    // }
    // go to specific page according to pagenumber strord in localstorage
    /* if (this.componentName == 'MyTasks'){
    var LSpageNumber: number = +localStorage.getItem('MyTasksSelectedPageNumber');
       if(LSpageNumber > 1 && LSpageNumber <= this.noOfPages){
        this.paginate(LSpageNumber);
       }
      } */
  }

  buildGrid(collection, pageSize) {
    this.gridViewSize = pageSize;
    this.gridHeaders = Object.keys(collection.Collection[0]).filter(g => g != "RequestId").filter(g => g != "Url")
      .filter(g => g != "AppInstanceID").filter(g => g != "ServiceId")
      .filter(g => g != "ETenderId").filter(g => g != "SupplierId")
      .filter(g => g != "HasUnreadMessage").filter(g => g != "EtenderCategoryAdmins")
      .filter(g => g != "ActivityInstanceID")
      .filter(g => g != "RequestStatusId").filter(g => g != "IsPostedToSCA").filter(g => g != "ReleaseFormRequestId")
      .filter(g => g != "EunitSignedAdmins");
    //Fill Sorting Array [Key & Direction]

    for (let i = 0; i < this.gridHeaders.length; i++) {
      this.sortingKeysDir[i] = new SortKey();
      this.sortingKeysDir[i].Identifier = this.gridHeaders[i];
      this.sortingKeysDir[i].IsAsc = true;
      this.sortingKeysDir[i].IsUpActive = false;
      this.sortingKeysDir[i].IsDownActive = false;
    }
    this.gridCollection = collection.Collection;
    this.addGridPagination();
    //Set Default Sort Keys & Direction
    this.currentUsedSortByKey = this.sortingKeysDir[0].Identifier;
    this.currentUsedSortDirKey = "ASC";
  }

  addGridPagination() {
    //Reset Paging Array
    this.noOfPagesArr = [];
    this.noOfPages = Math.ceil(this.collectionTotalCount / this.gridViewSize);
    for (let i = 0; i < this.noOfPages; i++) {
      this.noOfPagesArr.push(i + 1);
    }
    this.managePaginatation();
  }

  paginate(pageNumber) {
    this.global.isLoaderEnabled = true;
    this.currentPage = pageNumber;
    this.StoreSortandPagingCriteria();
    //set page number in local storage to return back to it backing to component
    localStorage.setItem('MyTasksSelectedPageNumber', pageNumber);

    if (this.componentName == 'MyTasks' ||this.componentName == 'ReleaseTasks' || this.componentName == 'SmallUnitsTasks' || this.componentName == 'CircularTasks'|| this.componentName == 'ChangeCrewTasks') {
      this.getCollectionPagedSorted(this.collectionPagedSortedEndPoint.replace("{PAGEINDEX}", (this.currentPage - 1).toString())
        .replace("{SORTBY1}", this.sortingColumns[1][0])
        .replace("{SORTDIR1}", this.sortingColumns[1][1] == "ASC" ? "ASC" : "DESC")
        .replace("{SORTBY2}", this.sortingColumns[0][0])
        .replace("{SORTDIR2}", this.sortingColumns[0][1] == "ASC" ? "ASC" : "DESC"));
    }
    else {
      this.getCollectionPagedSorted(this.collectionPagedSortedEndPoint.replace("{PAGEINDEX}", (this.currentPage - 1).toString())
        .replace("{SORTBY}", this.currentUsedSortByKey)
        .replace("{SORTDIR}", this.currentUsedSortDirKey));
    }

    this.scrollToTop();
    this.addGridPagination();
  }

  managePaginatation() {
    this.noOfPages;
    this.noOfPagesArr;
    this.collectionTotalCount;
    this.currentPage;

    if (this.noOfPages > 5) {
      if (this.currentPage <= 3) {
        this.showPrevDots = false;
        this.showNextDots = true;
        this.noOfPagesArr = this.noOfPagesArr.splice(0, 5);
      }
      else {
        if (this.noOfPages - this.currentPage >= 3) //if(this.currentPage > 3)
        {
          this.showPrevDots = true;
          this.showNextDots = true;
          this.noOfPagesArr = this.noOfPagesArr.splice(this.noOfPagesArr.indexOf(this.currentPage - 2), 5);
        }
        else //if(this.noOfPagesArr.length - this.currentPage < 5)
        {
          this.showPrevDots = true;
          this.showNextDots = false;
          this.noOfPagesArr = this.noOfPagesArr.splice(this.noOfPagesArr.indexOf(this.noOfPagesArr.length - 4), 5);
        }
      }
    }
  }

  getCollectionPagedSorted(collectionPagedSortedEndPoint) {
    this.gridViewService.getCollectionPagedSorted(collectionPagedSortedEndPoint).subscribe(

      data => {
        this.gridCollection = data.Data.Collection;
        if (this.IsHtml) {
          this.loadItemsMenu.emit(this.gridCollection);
        }
      },
      () => console.log("Something went wrong!!"),
      () => this.getCollectionPagedSortedSucceeded()

    );

  }

  handleClick(item, menuItem) {
    item.menu = menuItem;
    this.handleMenuItemClick.emit(item);
  }
  getCollectionPagedSortedSucceeded() {
    this.global.isLoaderEnabled = false;
  }

  scrollToTop() {
    const el = document.getElementById('main');
    el.scrollIntoView({ behavior: 'smooth' });
  }

  highlightSortingColumn(key, isAsc) {
    let activeSortingKeyDir: SortKey = this.sortingKeysDir.filter(k => k.IsUpActive || k.IsDownActive)[0];
    if (activeSortingKeyDir != undefined) {
      activeSortingKeyDir.isSortingHeader = false;
      activeSortingKeyDir.IsUpActive = false;
      activeSortingKeyDir.IsDownActive = false;
    }
    //Set Current Active Key
    let sortingKeyDir: SortKey = this.sortingKeysDir.filter(k => k.Identifier == key)[0];
    if (isAsc) {
      sortingKeyDir.IsUpActive = true;
      sortingKeyDir.IsAsc = false;
      this.currentUsedSortDirKey = "ASC";
      sortingKeyDir.isSortingHeader = true;
    } else {
      sortingKeyDir.IsDownActive = true;
      sortingKeyDir.IsAsc = true;
      this.currentUsedSortDirKey = "DESC";
      sortingKeyDir.isSortingHeader = true;
    }
  }

  highlightMultipleSortingColumn(key, isAsc) {
    //Set Current Active Key
    let sortingKeyDir: SortKey = this.sortingKeysDir.filter(k => k.Identifier == key)[0];
    if (isAsc) {
      sortingKeyDir.IsUpActive = true;
      sortingKeyDir.IsAsc = false;
      this.currentUsedSortDirKey = "ASC";
      sortingKeyDir.isSortingHeader = true;
    } else {
      sortingKeyDir.IsDownActive = true;
      sortingKeyDir.IsAsc = true;
      this.currentUsedSortDirKey = "DESC";
      sortingKeyDir.isSortingHeader = true;
    }
  }

  clearMultipleSortingColumns() {
    //clear active highlighted columns
    let activeSortingKeyDir: SortKey[] = this.sortingKeysDir.filter(k => k.IsUpActive || k.IsDownActive);
    if (activeSortingKeyDir != undefined && activeSortingKeyDir.length > 0) {
      for (let index = 0; index < activeSortingKeyDir.length; index++) {
        activeSortingKeyDir[index].isSortingHeader = false;
        activeSortingKeyDir[index].IsUpActive = false;
        activeSortingKeyDir[index].IsDownActive = false;
      }
    }
  }

  sort(key, isAsc) {
    if (this.componentName == 'LongHaulRequestsManagement') {
      this.global.isLoaderEnabled = true;
      //Check for Active Key [First Time => NULL]
      this.highlightSortingColumn(key, isAsc);
      this.getCollectionPagedSorted(this.collectionPagedSortedEndPoint.replace("{PAGEINDEX}", "0")
        .replace("{SORTBY}", key)
        .replace("{SORTDIR}", isAsc ? "ASC" : "DESC"));
      this.scrollToTop();
      this.currentPage = 1;
      this.currentUsedSortByKey = key;
    }
    else if (this.componentName == 'MyTasks' ||this.componentName == 'ReleaseTasks' || this.componentName == 'SmallUnitsTasks' || this.componentName == 'CircularTasks'|| this.componentName == 'ChangeCrewTasks') {
      this.global.isLoaderEnabled = true;
      var alreadyExistingSortingKey = false;
      this.sortingColumns.forEach((item) => {
        if (item[0] == key) {
          item[1] = isAsc ? "ASC" : "DESC";
          alreadyExistingSortingKey = true;
        }
      });

      if (alreadyExistingSortingKey == false)
        this.sortingColumns.push([key, isAsc ? "ASC" : "DESC"]);

      if (this.sortingColumns.length > 2)
        this.sortingColumns.shift();

      this.StoreSortandPagingCriteria();
      this.getCollectionPagedSorted(this.collectionPagedSortedEndPoint.replace("{PAGEINDEX}", "0")
        .replace("{SORTBY1}", this.sortingColumns[1][0])
        .replace("{SORTDIR1}", this.sortingColumns[1][1] == "ASC" ? "ASC" : "DESC")
        .replace("{SORTBY2}", this.sortingColumns[0][0])
        .replace("{SORTDIR2}", this.sortingColumns[0][1] == "ASC" ? "ASC" : "DESC"));

      this.clearMultipleSortingColumns();
      for (let index = 0; index < this.sortingColumns.length; index++) {
        this.highlightMultipleSortingColumn(this.sortingColumns[index][0], this.sortingColumns[index][1] == "ASC" ? true : false);
      }
      this.scrollToTop();
      this.currentPage = 1;
      this.currentUsedSortByKey = key;
    }
  }
public navigatedetails(requestId, navigateUrl,appInstanceId,ActivityInstanceID)
  {
    this.router.navigate([navigateUrl], { state: { data: { ActivityInstanceID, requestId, appInstanceId } } });
  }

  public navigate(requestId, navigateUrl, menuItemTitle: string, itemRequestNumber, appInstanceId, serviceId, supplierId, ActivityInstanceID, ReleaseFormRequestId, ReleaseRequestType,pendingAdmins?) {
    if ((this.currentLanguage == "En" && menuItemTitle.toLowerCase().indexOf("workflow") > -1)
      || (this.currentLanguage == "Ar" && menuItemTitle.toLowerCase().indexOf("مسار") > -1)) {
      let serviceProcessGUID = this.services.filter(s => s.Id == +itemRequestNumber.split("-")[1])[0].ProcessGUID;

      if (serviceId == Service.AgentRegisteration || serviceId == Service.SupplierRegistration) {
        this.baseRequestId = appInstanceId;
      } else {
        this.baseRequestId = requestId;
      }

      let navigateUrl = AppConfig.settings.apiServer.AdminSite
        + "/English/Services/Pages/WorkflowViewer.aspx?ifrmSrc="
        + "https://scawfdesigner.suezcanal.gov.eg/Diagram?AppInstanceID=" + this.baseRequestId + "&ProcessGUID=" + serviceProcessGUID + "&Mode=READONLY";
      // + "http://scaworkflows.linkdev.com/Diagram?AppInstanceID=" + this.baseRequestId + "&ProcessGUID=" + serviceProcessGUID + "&Mode=READONLY";
      //window.location.href = navigateUrl;
      window.open(navigateUrl, '_blank');
    }
    else if ((this.currentLanguage == "En" && menuItemTitle.toLowerCase().indexOf("history") > -1)
      || (this.currentLanguage == "Ar" && menuItemTitle.toLowerCase().indexOf("تاريخ") > -1)) {
      if (serviceId == Service.SupplierRegistration) {
        var splits = appInstanceId.split("_")
        requestId = splits[0];
      }
      this.router.navigate(["requestHistory"], { state: { data: { requestId, isRequestHistory: true, ReleaseFormRequestId, serviceId  } } });

    }
    else {
      if (history.state.data != null && history.state.data.isRequestHistory) {

        this.global.historyData.push({ reqHistoryData: window.history.state.data });

        this.router.navigate([navigateUrl], { state: { data: { ActivityInstanceID, requestId, appInstanceId, isCompleted: true, ReleaseFormRequestId: window.history.state.data.ReleaseFormRequestId, serviceId: window.history.state.data.serviceId   } } });
      }
      else if (window.location.hash.toLowerCase().indexOf("etendermessage") > -1)
        this.router.navigate([navigateUrl], { state: { data: { tenderId: requestId, appInstanceId, supplierId } } });
      else if (window.location.hash.toLowerCase().indexOf("mymessages") > -1)
        this.router.navigate([navigateUrl], { state: { data: { requestId, appInstanceId, isMyMessages: true } } });
      //Show Pending Etender Category Admins for division managers
      else if ((this.currentLanguage == "En" && menuItemTitle.toLowerCase().indexOf("admins") > -1)
        || (this.currentLanguage == "Ar" && menuItemTitle.toLowerCase().indexOf("المشرفون") > -1)) {
        if (pendingAdmins != null){
          var pendingAdminsList = "";
          Object.keys(pendingAdmins).forEach((key) => {
          pendingAdminsList += pendingAdmins[key] + "\n";
        })
        window.alert("Request Number: " + itemRequestNumber + " is pending on the following admins: \n\n" + pendingAdminsList);
        }
      } else if ((this.currentLanguage == "En" && menuItemTitle.toLowerCase().indexOf("passing") > -1)
        || (this.currentLanguage == "Ar" && menuItemTitle.toLowerCase().indexOf("عبور") > -1)) {
        this.router.navigate(["CircularRequest/ConfirmShipPassing"], { state: { data: { ActivityInstanceID, requestId, appInstanceId } } });
      }
      else if ((this.currentLanguage == "En" && menuItemTitle.toLowerCase().indexOf("refund") > -1)
        || (this.currentLanguage == "Ar" && menuItemTitle.toLowerCase().indexOf("تسوية") > -1)) {
        this.router.navigate(["CircularRequest/RefundClose"], { state: { data: { ActivityInstanceID, requestId, appInstanceId } } });

      }

      else if ((this.currentLanguage == "En" && menuItemTitle =="Release Form")
        || (this.currentLanguage == "Ar" && menuItemTitle =="Release Form")) {
        this.router.navigate(["ReleaseForm"], { state: { data: { ActivityInstanceID, requestId, appInstanceId } } });
      }
      else
        this.router.navigate([navigateUrl], { state: { data: { ActivityInstanceID, requestId, appInstanceId, ReleaseFormRequestId, serviceId } } });
    }
  }

  fillServicesDictionary(): void {
    //Agent Registration
    this.services[0] = new ServicesProcessGUID();
    this.services[0].Id = 1;
    this.services[0].ProcessGUID = "cdb769eb-d4e5-4674-b6bb-55580dbb1a86";
    //Fiberglass
    this.services[1] = new ServicesProcessGUID();
    this.services[1].Id = 6;
    this.services[1].ProcessGUID = "e3440b9e-2a63-4e27-a5d2-5b83f587397c";
    //Long Haul
    this.services[2] = new ServicesProcessGUID();
    this.services[2].Id = 2;
    this.services[2].ProcessGUID = "17875150-f8cc-40bb-9972-d25e6652775e";
    //Repair
    this.services[3] = new ServicesProcessGUID();
    this.services[3].Id = 4;
    this.services[3].ProcessGUID = "6bf7fa5e-ebba-46e6-b1fe-93b225998a94";
    //Salvage
    this.services[4] = new ServicesProcessGUID();
    this.services[4].Id = 3;
    this.services[4].ProcessGUID = "c131ae47-21d6-4666-950e-336dc9cd0291";
    //Floating Cranes
    this.services[5] = new ServicesProcessGUID();
    this.services[5].Id = 7;
    this.services[5].ProcessGUID = "c5424453-da5f-4764-bc01-daa942871729";
    //Quality
    this.services[6] = new ServicesProcessGUID();
    this.services[6].Id = 5;
    this.services[6].ProcessGUID = "4c357727-4e61-4113-a5ba-db7f6f0f1932";


    //Fees Estimation
    this.services[7] = new ServicesProcessGUID();
    this.services[7].Id = 13;
    this.services[7].ProcessGUID = "b404ad24-2b0b-4513-affc-0a28f7295123";
    //Transit Request
    this.services[8] = new ServicesProcessGUID();
    this.services[8].Id = 17;
    this.services[8].ProcessGUID = "3ac4fa0a-936b-436d-b65f-389311e640cb";
    //Update Agent Profile
    this.services[9] = new ServicesProcessGUID();
    this.services[9].Id = 16;
    this.services[9].ProcessGUID = "2369b2a3-0c38-4268-8519-d3c30ae2fa90";

    //supplier Registration
    this.services[10] = new ServicesProcessGUID();
    this.services[10].Id = 9;
    this.services[10].ProcessGUID = "6ec8d952-f39e-4e8a-89b6-b65662a6d579";

    //Dynamic Balancing
    this.services[11] = new ServicesProcessGUID();
    this.services[11].Id = 12;
    this.services[11].ProcessGUID = "4c357727-4e61-4113-a5ba-db7f6f0f1932";

    //Hardeness Test
    this.services[12] = new ServicesProcessGUID();
    this.services[12].Id = 11;
    this.services[12].ProcessGUID = "4c357727-4e61-4113-a5ba-db7f6f0f1932";

    //Non Destructive
    this.services[13] = new ServicesProcessGUID();
    this.services[13].Id = 10;
    this.services[13].ProcessGUID = "4c357727-4e61-4113-a5ba-db7f6f0f1932";

    // Small Units
    this.services[14] = new ServicesProcessGUID();
    this.services[14].Id = 27;
    this.services[14].ProcessGUID = "8350e152-08cb-43e5-9c7f-0052b3c5d0a6";

    // Circulars
    this.services[15] = new ServicesProcessGUID();
    this.services[15].Id = 28;
    this.services[15].ProcessGUID = "ef444498-e3ef-4039-be7e-b2ebcd358f78";
  }

  getCellText(cellText) {
    if (cellText != null && cellText != undefined) {
      if (cellText.toString().indexOf("--") > -1 && window.location.hash.toLowerCase().indexOf("requesthistory") > -1) {
        return this.currentLanguage == "En" ? cellText.toString().split("--")[0] : cellText.toString().split("--")[1];
      }
      else
        return cellText;
    }
  }

  loadSortandPagingCriteria() {
    if (this.componentName == 'MyTasks' || this.componentName == 'ReleaseTasks' ||this.componentName == 'SmallUnitsTasks' || this.componentName == 'CircularTasks'|| this.componentName == 'ChangeCrewTasks') {
      if (this.global.myTasksSortsndPagingCriteria.length > 0) {

        this.sortingColumns = this.global.myTasksSortsndPagingCriteria[0].sortingColumns;
        this.currentPage = this.global.myTasksSortsndPagingCriteria[0].currentPage;
        //check if stored page no became more than the number of pages after closing task
        if (this.currentPage > this.noOfPages) {
          this.currentPage = 1;
        }
        //this.global.myTasksSortsndPagingCriteria = [];

      }
    }

  }

  StoreSortandPagingCriteria() {
    if (this.componentName == 'MyTasks' || this.componentName == 'ReleaseTasks' ||this.componentName == 'SmallUnitsTasks' || this.componentName == 'CircularTasks'|| this.componentName == 'ChangeCrewTasks') {
      this.global.myTasksSortsndPagingCriteria = [];
      //var sColumns: string[][] = this.sortingColumns;
      this.global.myTasksSortsndPagingCriteria.push({
        sortingColumns: this.sortingColumns,
        currentPage: this.currentPage,

      });
    }

  }
}

export class SortKey {
  Identifier: string;
  IsAsc: boolean;
  IsUpActive: boolean;
  IsDownActive: boolean;
  isSortingHeader: boolean;
};

export class ServicesProcessGUID {
  Id: number;
  ProcessGUID: string;
};
